import {BusinessHours, Timezone} from '@wix/answers-api';
import * as moment from 'moment-timezone';

type Day = 'sunday' | 'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday';

export const isChatOpen = (businessHours: BusinessHours, timezone: Timezone): boolean => {
	if (businessHours.openTwentyFourSeven) {
		return true;
	}

	const dateInTenantTimezone = moment(Date.now()).tz(timezone);
	const day = dateInTenantTimezone.format('dddd').toLowerCase() as Day;
	const daySettings = businessHours[day];
	if (!daySettings.enabled) {
		return false;
	}

	const currentHour = dateInTenantTimezone.hour();
	const currentMinutes = dateInTenantTimezone.minutes();
	const [startHour, startMinutes] = daySettings.start;
	const [endHour, endMinutes] = daySettings.end;

	const isAfterOpenTime = currentHour > startHour || (currentHour === startHour && currentMinutes >= startMinutes);
	const isBeforeCloseTime = currentHour < endHour || (currentHour === endHour && currentMinutes < endMinutes);
	return isAfterOpenTime && isBeforeCloseTime;
};
